import { message } from "antd";
import Candidate from "redux/models/candidate";

export const useCandidateFieldEdit = (
  candidateJobEntry,
  setCandidateJobEntry,
  onCandidateChanged,
) => {
  return (fieldKey, isCje = false, options = {}) =>
    async (newValue) => {
      const { stateTransform, apiKey } = options;
      const {
        candidate,
        jobSource,
        status,
        id: cjeId,
        sourcesId,
        candidateJobRecruiters,
        ...cjeFields
      } = candidateJobEntry;
      try {
        const res = await Candidate.edit({
          ...candidate,
          ...cjeFields,
          id: candidate.id,
          candidateEntryId: cjeId,
          jobSourcesId: jobSource.id,
          clientsId: jobSource.clientsId,
          sourceId: sourcesId,
          candidateJobRecruiters: candidateJobRecruiters?.map((r) => r.id),
          [apiKey ?? fieldKey]: newValue,
        });
        setCandidateJobEntry(res);
        onCandidateChanged?.(res);
        message.success("Updated successfully");
      } catch (e) {
        message.error(e.message);
      }
    };
};
